module.exports = __webpack_public_path__ + "static/film2-ecc019a161618f895c5f20406c93628a.jpg";